import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
  standalone: true
})
export class RedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private loginService = inject(LoginService);
  private platformId = inject(PLATFORM_ID);


  ssoCode: string;
  redirectUrl: string;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)){
      this.route.queryParams
        .subscribe(params => {
            this.ssoCode = params.code;
            if (this.ssoCode) {
              this.loginService.loginByCode(this.ssoCode).subscribe((result) => {
                this.redirectUrl = params.redirectUrl ?? '/offer';
                this.router.navigate([this.redirectUrl]);
              });
            } else {
              this.router.navigate(['/offer']);
            }
          }
        );
    }
  }

}
